/**
 * Classe per la gestione di: caricamento dati da CSV, filtri, calcoli di rating e interfaccia utente
 */
class PuntaBanca {
    constructor() {
        this.csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ6ULN8HIs6QGCHWHzEffim38PgAHL6wfaEhNcaY_wcWLtHsN0KVm1fSRS9FisEHQ/pub?gid=668109679&single=true&output=csv';
        // Dati grezzi dal CSV senza filtri applicati
        this.rawData = [];
        // Dati filtrati in base ai criteri dell'utente
        this.filteredData = [];
        // Configurazione di paginazione
        this.currentPage = 1;
        this.itemsPerPage = 10;
        // Dati della riga attualmente selezionata per il calcolatore
        this.currentRowData = null;
        // Filtri selezionati dall'utente per bookmaker, mercati e leghe
        this.selectedFilters = {
            bookmakers: [],
            markets: [],
            leagues: []
        };
        // Flag per modalità CR - calcoli diversi quando attiva
        this.isCRMode = false;

        this.init();
    }

    /**
     * Inizializza l'applicazione seguendo un ordine specifico:
     * 1. Reset input per stato pulito
     * 2. Binding eventi per interattività
     * 3. Caricamento dati dal CSV
     * 4. Creazione dropdown personalizzati
     */
    init() {
        this.resetAllInputs();
        this.bindEvents();
        this.loadData();
        this.initCustomSelects();
    }

    /**
     * Inizializza i dropdown personalizzati
     */
    initCustomSelects() {        
        ['bookmakers', 'markets', 'leagues'].forEach(filterType => {
            this.createCustomSelect(filterType);
        });
    }

    /**
     * Crea un dropdown personalizzato sostituendo il select nativo
     * Include header cliccabile, lista opzioni con checkbox e azioni
     * @param {string} filterType - Tipo di filtro (bookmakers/markets/leagues)
     */
    createCustomSelect(filterType) {
        const container = document.getElementById(`${filterType}FilterContainer`);
        if (!container) return;

        // Mapping dei nomi per l'interfaccia utente
        const filterNames = {
            bookmakers: 'bookmaker',
            markets: 'mercati',
            leagues: 'leghe'
        };
        // Creazione struttura HTML del dropdown personalizzato
        const customSelect = document.createElement('div');
        customSelect.className = 'custom-select';
        customSelect.innerHTML = `
            <div class="select-header" id="${filterType}-header">
                <span class="select-placeholder">Seleziona ${filterNames[filterType]}</span>
                <span class="select-arrow">▼</span>
            </div>
            <div class="select-dropdown" id="${filterType}-dropdown">
                <div class="select-options" id="${filterType}-options">
                    <!-- Options will be populated here -->
                </div>
                <div class="select-actions">
                    <button type="button" class="select-clear" onclick="app.clearSingleFilter('${filterType}')">Pulisci</button>
                    <button type="button" class="select-close" onclick="app.closeDropdown('${filterType}')">Chiudi</button>
                </div>
            </div>
        `;

        // Nasconde il select originale e aggiunge quello personalizzato
        const originalSelect = document.getElementById(`${filterType}Filter`);
        if (originalSelect) {
            originalSelect.style.display = 'none';
            container.appendChild(customSelect);
        }

        // Event listener per aprire/chiudere il dropdown
        const header = document.getElementById(`${filterType}-header`);
        const dropdown = document.getElementById(`${filterType}-dropdown`);        
        header.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleDropdown(filterType);
        });

        // Chiude il dropdown quando si clicca fuori dal componente
        document.addEventListener('click', (e) => {
            if (!customSelect.contains(e.target)) {
                dropdown.classList.remove('open');
            }
        });
    }

     /**
     * Gestisce l'apertura/chiusura dei dropdown personalizzati
     * Chiude tutti gli altri dropdown quando ne apre uno nuovo
     * @param {string} filterType - Tipo di filtro da aprire/chiudere
     */
    toggleDropdown(filterType) {
        // Chiude tutti gli altri dropdown per evitare sovrapposizioni
        ['bookmakers', 'markets', 'leagues'].forEach(type => {
            if (type !== filterType) {
                const dropdown = document.getElementById(`${type}-dropdown`);
                if (dropdown) dropdown.classList.remove('open');
            }
        });

        // Toggle del dropdown richiesto
        const dropdown = document.getElementById(`${filterType}-dropdown`);
        if (dropdown) {
            dropdown.classList.toggle('open');
        }
    }

    /**
     * Chiude un dropdown specifico
     * @param {string} filterType - Tipo di filtro da chiudere
     */
    closeDropdown(filterType) {
        const dropdown = document.getElementById(`${filterType}-dropdown`);
        if (dropdown) {
            dropdown.classList.remove('open');
        }
    }

    /**
     * Configura tutti gli event listener dell'applicazione
     * Organizzati per categorie: controlli, filtri, modal
     */
    bindEvents() {
        // Event listener per i controlli
        document.getElementById('refreshData').addEventListener('click', () => this.loadData());        
        document.getElementById('clearFilters').addEventListener('click', () => this.clearFilters());
        document.getElementById('previousPage').addEventListener('click', () => this.changePage(-1));
        document.getElementById('nextPage').addEventListener('click', () => this.changePage(1));        
        // Event listener per i filtri
        document.getElementById('startingDate').addEventListener('change', () => this.applyFilters());
        document.getElementById('endingDate').addEventListener('change', () => this.applyFilters());
        document.getElementById('minOdds').addEventListener('input', () => this.applyFilters());
        document.getElementById('maxOdds').addEventListener('input', () => this.applyFilters());
        document.getElementById('teamSearch').addEventListener('input', () => this.applyFilters());
        document.getElementById('betfairCommission').addEventListener('input', () => {
            // Quando cambia la commissione, ricalcola tutto
            if (this.isCRMode) {
                // In modalità CR, applica direttamente i filtri che gestiranno il calcolo CR
                this.applyFilters();
            } else {
                // In modalità normale, ricalcola i rating standard
                this.recalculateRatings();
            }
        });
        // Input per modalità CR - attivano controllo automatico della modalità
        document.getElementById('stake').addEventListener('input', () => this.checkCRMode());
        document.getElementById('refund').addEventListener('input', () => this.checkCRMode());
        // Event listener per il calcolatore modal
        // Chiusura modal con pulsante X
        document.querySelector('.close').addEventListener('click', () => this.closeModal());        
        // Chiusura modal cliccando fuori dall'area del contenuto
        window.addEventListener('click', (e) => {
            const modal = document.getElementById('calculatorModal');
            if (e.target === modal) {
                this.closeModal();
            }
        });
        // Chiusura modal con tasto ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const modal = document.getElementById('calculatorModal');
                // Chiude solo se il modal è visibile
                if (modal.style.display === 'block') {
                    this.closeModal();
                }
            }
        });
    }

    /**
     * Carica i dati dal CSV remoto e li processa
     * Gestisce stati di loading, errori e successo
     */
    async loadData() {
        // Gestione stati UI durante il caricamento
        const loading = document.getElementById('loading');
        const error = document.getElementById('error');
        const tableContainer = document.getElementById('tableContainer');

        loading.style.display = 'block';
        error.style.display = 'none';
        tableContainer.style.display = 'none';

        try {
            // Fetch del CSV da Google Drive
            const response = await fetch(this.csvUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }            
            const csvText = await response.text();            
            // Parsing CSV con Papa Parse per robustezza
            Papa.parse(csvText, {
                // Prima riga come intestazioni
                header: true,
                // Ignora righe vuote
                skipEmptyLines: true,
                // Mantiene tutto come stringa per controllo manuale
                dynamicTyping: false,
                complete: (results) => {
                    // Pulizia headers da spazi che possono causare problemi
                    this.rawData = results.data.map(row => {
                        const cleanedRow = {};
                        Object.keys(row).forEach(key => {
                            const cleanKey = key.trim();
                            cleanedRow[cleanKey] = row[key];
                        });
                        return cleanedRow;
                    });
                    
                    this.populateCustomSelects();
                    // Ricalcola i rating con la commissione attuale
                    this.recalculateRatings();
                    // Riapplica tutti i filtri esistenti
                    this.applyFilters();
                    this.populateCustomSelects();
                    this.currentPage = 1;
                    
                    // Aggiorna UI per mostrare i dati
                    loading.style.display = 'none';
                    tableContainer.style.display = 'block';
                },
                error: (err) => {
                    throw new Error(`Errore nel parsing CSV: ${err.message}`);
                }
            });
        } catch (err) {
            loading.style.display = 'none';
            error.style.display = 'block';
            error.textContent = `Errore nel caricamento dei dati: ${err.message}`;
            console.error('Errore:', err);
        }
    }

    /**
     * Popola i dropdown personalizzati con valori unici estratti dai dati
     * Estrae valori distinti per ogni tipo di filtro
     */
    populateCustomSelects() {
        // Filtro bookmaker
        const bookmakers = [...new Set(this.rawData.map(row => row.Bookmaker?.split(' - ')[0]).filter(Boolean))];
        this.populateCustomSelect('bookmakers', bookmakers);

        // Filtro mercati
        const markets = [...new Set(this.rawData.map(row => row.Mercati?.split(' - ')[0]).filter(Boolean))];
        this.populateCustomSelect('markets', markets);

        // Filtro leghe
        const leagues = [...new Set(this.rawData.map(row => row.Lega).filter(Boolean))];
        this.populateCustomSelect('leagues', leagues);
    }

    /**
     * Popola un singolo dropdown personalizzato con le opzioni fornite
     * Crea checkbox per selezione multipla
     * @param {string} filterType - Tipo di filtro
     * @param {Array} options - Array di opzioni da mostrare
     */
    populateCustomSelect(filterType, options) {
        const optionsContainer = document.getElementById(`${filterType}-options`);
        if (!optionsContainer) return;

        optionsContainer.innerHTML = '';

        // Ordina le opzioni alfabeticamente per migliore UX
        options.sort().forEach(option => {
            const optionElement = document.createElement('div');
            optionElement.className = 'select-option';
            optionElement.innerHTML = `
                <label class="checkbox-label">
                    <input type="checkbox" value="${option}" onchange="app.handleCheckboxChange('${filterType}', '${option}', this.checked)">
                    <span class="checkbox-custom"></span>
                    <span class="option-text">${option}</span>
                </label>
            `;
            optionsContainer.appendChild(optionElement);
        });
    }

    /**
     * Gestisce il cambiamento stato delle checkbox nei filtri
     * Aggiorna l'array dei filtri selezionati e riapplica i filtri
     * @param {string} filterType - Tipo di filtro
     * @param {string} value - Valore selezionato/deselezionato
     * @param {boolean} isChecked - Stato della checkbox
     */
    handleCheckboxChange(filterType, value, isChecked) {
        if (isChecked) {
            // Aggiunge il valore se non già presente
            if (!this.selectedFilters[filterType].includes(value)) {
                this.selectedFilters[filterType].push(value);
            }
        } else {
            // Rimuove il valore dai filtri selezionati
            this.selectedFilters[filterType] = this.selectedFilters[filterType].filter(v => v !== value);
        }

        // Aggiorna l'header del dropdown e riapplica i filtri
        this.updateSelectHeader(filterType);
        this.applyFilters();
    }

    /**
     * Aggiorna il testo nell'header del dropdown in base alle selezioni
     * Mostra placeholder, singola selezione o conteggio selezioni multiple
     * @param {string} filterType - Tipo di filtro da aggiornare
     */
    updateSelectHeader(filterType) {
        const header = document.getElementById(`${filterType}-header`);
        const placeholder = header.querySelector('.select-placeholder');
        
        if (!placeholder) return;

        const selected = this.selectedFilters[filterType];
        const filterNames = {
            bookmakers: 'bookmaker',
            markets: 'mercati',
            leagues: 'leghe'
        };

        // Aggiorna il testo in base al numero di selezioni
        if (selected.length === 0) {
            placeholder.textContent = `Seleziona ${filterNames[filterType]}`;
            header.classList.remove('has-selection');
        } else if (selected.length === 1) {
            placeholder.textContent = selected[0];
            header.classList.add('has-selection');
        } else {
            placeholder.textContent = `${selected.length} ${filterNames[filterType]} selezionati`;
            header.classList.add('has-selection');
        }
    }

    /**
     * Pulisce i filtri per un singolo tipo di dropdown
     * @param {string} filterType - Tipo di filtro da pulire
     */
    clearSingleFilter(filterType) {
        this.selectedFilters[filterType] = [];
        
        // Deseleziona tutte le checkbox
        const checkboxes = document.querySelectorAll(`#${filterType}-options input[type="checkbox"]`);
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });

        this.updateSelectHeader(filterType);
        this.applyFilters();
    }

    /**
     * Parsing robusto delle date supportando diversi formati
     * Gestisce formati italiani (dd/mm/yyyy) e internazionali (yyyy-mm-dd)
     * @param {string} dateString - Stringa data da parsare
     * @returns {Date|null} Oggetto Date o null se parsing fallisce
     */
    parseDate(dateString) {
        if (!dateString) return null;
        
        // Formati supportati con regex specifiche
        const formats = [
            /(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})/, // dd/mm/yyyy hh:mm
            /(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2})/, // yyyy-mm-dd hh:mm
            /(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{2})/ // dd-mm-yyyy hh:mm
        ];

        for (let format of formats) {
            const match = dateString.match(format);
            if (match) {
                if (format === formats[0] || format === formats[2]) {
                    // dd/mm/yyyy o dd-mm-yyyy
                    const day = parseInt(match[1]);
                    const month = parseInt(match[2]) - 1; // I mesi in JavaScript sono 0-indexed
                    const year = parseInt(match[3]);
                    const hour = parseInt(match[4]);
                    const minute = parseInt(match[5]);
                    return new Date(year, month, day, hour, minute);
                } else {
                    // yyyy-mm-dd
                    const year = parseInt(match[1]);
                    const month = parseInt(match[2]) - 1;
                    const day = parseInt(match[3]);
                    const hour = parseInt(match[4]);
                    const minute = parseInt(match[5]);
                    return new Date(year, month, day, hour, minute);
                }
            }
        }
        
        return null;
    }

    /**
     * Ricalcola i rating standard per tutte le righe con la commissione corrente
     * Usa la formula standard del matched betting per calcolare il rating
     */
    recalculateRatings() {
        const commissionInput = document.getElementById('betfairCommission').value;
        const commission = commissionInput === '' ? 0.045 : parseFloat(commissionInput) / 100;
        
        this.rawData = this.rawData.map(row => {
            const odds = row.Quote.split(' - ');
            if (odds.length >= 2) {
                const bets = [parseFloat(odds[0]), parseFloat(odds[1])];
                if (!isNaN(bets[0]) && !isNaN(bets[1])) {
                    const stakeA = 100;
                    const stakeB = Math.round(bets[0] * stakeA / (bets[1] - commission) * 100) / 100;
                    const lossA = (bets[0] * stakeA - stakeA) - (bets[1] * stakeB - stakeB);
                    const lossB = stakeB * (1 - commission) - stakeA;
                    const ratingA = (1 + lossA / stakeA) * 100;
                    const ratingB = (1 + lossB / stakeA) * 100;
                    const rating = Math.round(Math.min(ratingA, ratingB) * 100) / 100;
                    
                    return { ...row, Rating: rating.toString() };
                }
            }
            return row;
        });
        
        this.applyFilters();
    }

    /**
     * Applica tutti i filtri attivi ai dati grezzi
     * Gestisce filtri per bookmaker, mercati, leghe, date, quote e ricerca team
     * In modalità CR applica calcoli diversi
     */
    applyFilters() {
        // Recupera valori dai filtri UI
        const startingDate = document.getElementById('startingDate').value;
        const endingDate = document.getElementById('endingDate').value;
        const minOdds = parseFloat(document.getElementById('minOdds').value) || 0;
        const maxOdds = parseFloat(document.getElementById('maxOdds').value) || Infinity;
        const teamSearch = document.getElementById('teamSearch').value.toLowerCase().trim();

        this.filteredData = this.rawData.filter(row => {
            // Filtro bookmaker
            if (this.selectedFilters.bookmakers.length > 0) {
                const rowBookmaker = row.Bookmaker?.split(' - ')[0];
                if (!this.selectedFilters.bookmakers.includes(rowBookmaker)) return false;
            }
            // Filtro mercati
            if (this.selectedFilters.markets.length > 0) {
                const rowMercato = row.Mercati?.split(' - ')[0];
                if (!this.selectedFilters.markets.includes(rowMercato)) return false;
            }
            // Filtro leghe
            if (this.selectedFilters.leagues.length > 0) {
                if (!this.selectedFilters.leagues.includes(row.Lega)) return false;
            }
            // Filtro data
            if (startingDate || endingDate) {
                const matchDate = this.parseDate(row['Data e ora']);
                if (matchDate) {
                    if (startingDate) {
                        const startDate = new Date(startingDate);
                        if (matchDate < startDate) return false;
                    }
                    if (endingDate) {
                        const endDate = new Date(endingDate);
                        endDate.setHours(23, 59, 59, 999); // Include tutto il giorno
                        if (matchDate > endDate) return false;
                    }
                }
            }

            // Filtro quote - prende la prima quota dalla colonna Quote
            const odds = this.getFirstOdds(row.Quote);
            if (odds < minOdds || odds > maxOdds) return false;

            // Filtro ricerca squadra
            if (teamSearch) {
                const home = (row.Casa || '').toLowerCase();
                const away = (row.Ospite || '').toLowerCase();
                if (!home.includes(teamSearch) && !away.includes(teamSearch)) return false;
            }

            return true;
        });

        // Se la modalità CR è attiva, ricalcola i rating con formula CR e ordina per rating decrescente
        if (this.isCRMode) {
            const stake = parseFloat(document.getElementById('stake').value);
            const refund = parseFloat(document.getElementById('refund').value);
            const commissionInput = document.getElementById('betfairCommission').value;
            const commission = commissionInput === '' ? 0.045 : parseFloat(commissionInput) / 100;
            
            this.filteredData = this.filteredData.map(row => {
                const odds = row.Quote.split(' - ');
                if (odds.length >= 2) {
                    const oddsA = parseFloat(odds[0]);
                    const oddsB = parseFloat(odds[1]);
                    if (!isNaN(oddsA) && !isNaN(oddsB)) {
                        const stakeA = stake;
                        const stakeB = (oddsA * stakeA - refund) / (oddsB - commission);
                        const lossA = (oddsA * stakeA - stakeA) - (oddsB * stakeB - stakeB);
                        const lossB = stakeB * (1 - commission) - stakeA + refund;
                        const ratingA = lossA / refund;
                        const ratingB = lossB / refund;
                        const rating = Math.min(ratingA, ratingB) * 100;
                    
                        return { ...row, Rating: rating.toFixed(2) };
                    }
                }
                return row;
            });
            
            // Ordina in modo decrescente per rating in modalità CR
            this.filteredData.sort((a, b) => parseFloat(b.Rating) - parseFloat(a.Rating));
        }

        // Reset paginazione e aggiorna visualizzazione
        this.currentPage = 1;
        this.renderTable();
        this.updatePagination();
    }

    /**
     * Reset completo di tutti i filtri e stato dell'applicazione
     * Riporta l'app allo stato iniziale
     */
    clearFilters() {
        // Reset filtri dropdown personalizzati
        this.selectedFilters = {
            bookmakers: [],
            markets: [],
            leagues: []
        };

        // Reset dei custom selects
        ['bookmakers', 'markets', 'leagues'].forEach(filterType => {
            const checkboxes = document.querySelectorAll(`#${filterType}-options input[type="checkbox"]`);
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            this.updateSelectHeader(filterType);
        });
        
        // Reset degli altri filtri
        document.getElementById('startingDate').value = '';
        document.getElementById('endingDate').value = '';
        document.getElementById('minOdds').value = '';
        document.getElementById('maxOdds').value = '';        
        document.getElementById('teamSearch').value = '';
        document.getElementById('betfairCommission').value = '4.5';
        document.getElementById('stake').value = '';
        document.getElementById('refund').value = '';

        // Ricalcola con valori di default e reset stato
        this.recalculateRatings();
        this.filteredData = [...this.rawData];
        this.currentPage = 1;
        this.isCRMode = false;        
        this.renderTable();
        this.updatePagination();
    }

    /**
     * Reset di tutti gli input al caricamento iniziale della pagina
     * Garantisce uno stato pulito all'avvio
     */
    resetAllInputs() {
        document.getElementById('startingDate').value = '';
        document.getElementById('endingDate').value = '';
        document.getElementById('minOdds').value = '';
        document.getElementById('maxOdds').value = '';        
        document.getElementById('teamSearch').value = '';
        document.getElementById('betfairCommission').value = '4.5';
        document.getElementById('stake').value = '';
        document.getElementById('refund').value = '';
    }

    /**
     * Controlla se attivare la modalità CR
     * Si attiva quando sia stake che refund hanno valori > 0
     * Cambia automaticamente i calcoli e l'ordinamento
     */
    checkCRMode() {
        const stake = parseFloat(document.getElementById('stake').value) || 0;
        const refund = parseFloat(document.getElementById('refund').value) || 0;
        
        const wasCRMode = this.isCRMode;
        this.isCRMode = stake > 0 && refund > 0;
        
        if (wasCRMode !== this.isCRMode || this.isCRMode) {
            this.applyFilters();
        }
    }

    /**
     * Estrae la prima quota numerica da una stringa di quote
     * Usata per i filtri min/max odds
     * @param {string} oddstring - Stringa contenente le quote
     * @returns {number} Prima quota trovata o 0 se nessuna
     */
    getFirstOdds(oddstring) {
        if (!oddstring) return 0;
        // Regex per trovare il primo numero decimale
        const match = oddstring.match(/[\d.]+/);
        return match ? parseFloat(match[0]) : 0;
    }

    /**
     * Renderizza la tabella con i dati filtrati per la pagina corrente
     * Gestisce paginazione e differenze tra modalità normale e CR
     */
    renderTable() {
        const tbody = document.getElementById('tableBody');
        tbody.innerHTML = '';

        // Calcola il range di elementi da visualizzare per la paginazione
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        const pageData = this.filteredData.slice(start, end);

        // Aggiorna header della colonna rating in base alla modalità
        const ratingHeader = document.getElementById('rating-header');
        if (ratingHeader) {
            ratingHeader.textContent = this.isCRMode ? 'CR' : 'Rating';
        }
        
        // Itera attraverso ogni riga di dati della pagina corrente
        pageData.forEach((row, index) => {
            const tr = document.createElement('tr');
            const odds = row.Quote.split(' - ').map(n => parseFloat(n).toFixed(2)).join(' - ');
            const rating = parseFloat(row.Rating).toFixed(2) + "%" || '';
            
            tr.innerHTML = `
                <td>${row.Casa || ''}</td>
                <td>${row.Ospite || ''}</td>
                <td>${row['Data e ora'] || ''}</td>
                <td>${row.Lega || ''}</td>
                <td>${row.Mercati?.split(' - ')[0] || ''}</td>
                <td>${row.Bookmaker || ''}</td>
                <td>${odds || ''}</td>
                <td>${rating}</td>
                <td>
                    <button class="btn btn-small btn-primary" onclick="app.openCalculator(${start + index})">
                        🧮
                    </button>
                </td>
            `;
            tbody.appendChild(tr);
        });

        // Mostra/nasconde i controlli di paginazione in base al numero di elementi
        document.getElementById('pagination').style.display = this.filteredData.length > this.itemsPerPage ? 'flex' : 'none';
    }

    /**
    * Aggiorna i controlli di paginazione (info pagina e stato bottoni)
    */
    updatePagination() {
        const totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);
        document.getElementById('pageInfo').textContent = `Pagina ${this.currentPage} di ${totalPages}`;
        document.getElementById('previousPage').disabled = this.currentPage === 1;
        document.getElementById('nextPage').disabled = this.currentPage === totalPages;
    }

    /**
    * Cambia pagina nella tabella
    * @param {number} direction - Direzione del cambio pagina (+1 o -1)
    */
    changePage(direction) {
        const totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);
        this.currentPage += direction;        
        if (this.currentPage < 1) this.currentPage = 1;
        if (this.currentPage > totalPages) this.currentPage = totalPages;
        
        this.renderTable();
        this.updatePagination();
    }

    /**
    * Apre il modal del calcolatore
    * @param {number} index - Indice della riga nei dati filtrati
    */
    openCalculator(index) {
        this.currentRowData = this.filteredData[index];
        const modal = document.getElementById('calculatorModal');
        
        // Popola i dati del match
        document.getElementById('matchTitle').textContent = 
            `${this.currentRowData.Casa || ''} - ${this.currentRowData.Ospite || ''}`;
        document.getElementById('matchDetails').textContent = 
            `${this.currentRowData.Lega || ''} - ${this.currentRowData['Data e ora'] || ''}`;        
        // Aggiunge i mercati
        const markets = this.currentRowData.Mercati?.split(' - ')[0] || '';
        document.getElementById('matchMarkets').textContent = `Mercato ${markets}`;
        // Imposta la commissione exchange dal campo principale
        const mainCommission = document.getElementById('betfairCommission').value;
        document.getElementById('exchangeCommission').value = mainCommission || '4.5';
        // Gestisce la preimpostazione per modalità CR
        if (this.isCRMode) {
            // Preseleziona la modalità rimborso
            document.querySelector('input[name="betType"][value="rimborso"]').checked = true;            
            // Abilita il campo refund
            document.getElementById('refundValue').disabled = false;            
            // Popola i campi con i valori dalla modalità CR
            const stakeValue = document.getElementById('stake').value;
            const refundValueFromMain = document.getElementById('refund').value;            
            document.getElementById('stakeA').value = stakeValue || '';
            document.getElementById('refundValue').value = refundValueFromMain || '';
        } else {
            // Modalità normale - mantiene la selezione predefinita "normale"
            document.querySelector('input[name="betType"][value="normale"]').checked = true;
            document.getElementById('refundValue').disabled = true;
            document.getElementById('refundValue').value = '';
            document.getElementById('stakeA').value = '';
        }
        // Estrae le quote e popola i campi
        const odds = this.parseOdds(this.currentRowData.Quote);
        document.getElementById('oddsA').value = parseFloat(odds.bookmaker).toFixed(2) || '';
        document.getElementById('oddsB').value = parseFloat(odds.exchange).toFixed(2) || '';
        // Gestisce i link dei bookmaker
        const bookmakerParts = this.currentRowData.Bookmaker?.split(' - ') || [];
        const linkParts = this.currentRowData.Link?.split(' - ') || [];
        // Primo bookmaker
        const bookmaker1Name = bookmakerParts[0] || 'Bookmaker 1';
        const bookmaker1Link = linkParts[0] || '#';
        const matchLinkA = document.getElementById('matchLinkA');
        matchLinkA.textContent = bookmaker1Name;
        matchLinkA.href = bookmaker1Link;
        // Secondo bookmaker
        const bookmaker2Name = bookmakerParts[1] || 'Exchange';
        const bookmaker2Link = linkParts[1] || '#';
        const matchLinkB = document.getElementById('matchLinkB');
        matchLinkB.textContent = bookmaker2Name;
        matchLinkB.href = bookmaker2Link;
        
        // Reset valori        
        document.getElementById('stakeB').textContent = '';
        document.getElementById('profit').textContent = '';
        document.getElementById('rating').textContent = '';
        
        // Associa event listener per i calcoli in tempo reale
        this.bindCalculatorEvents();
        // Se ci sono già valori preimpostati, calcola immediatamente
        this.calculateRealTime();
        
        modal.style.display = 'block';
    }

    /**
    * Parsing delle quote da una stringa formattata
    * @param {string} oddstring - Stringa contenente le quote separate da " - "
    * @returns {Object} Oggetto con quote del bookmaker e dell'exchange
    */
    parseOdds(oddstring) {
        if (!oddstring) return { bookmaker: null, exchange: null };
        
        const parts = oddstring.split(' - ');
        return {
            bookmaker: parts[0] ? parseFloat(parts[0]) : null,
            exchange: parts[1] ? parseFloat(parts[1]) : null
        };
    }

    /**
    * Chiude il modal del calcolatore
    */
    closeModal() {
        document.getElementById('calculatorModal').style.display = 'none';
    }

    /**
    * Associa gli event listener per i calcoli in tempo reale
    * Gestisce i cambiamenti nei campi per aggiornare automaticamente i risultati
    */
    bindCalculatorEvents() {
        // Event listener per il cambio tipo di scommessa
        document.querySelectorAll('input[name="betType"]').forEach(radio => {
            radio.addEventListener('change', () => {
                const refund = document.getElementById('refundValue');
                // Abilita il campo rimborso solo se il tipo è "rimborso"
                refund.disabled = radio.value !== 'rimborso';
                if (radio.value !== 'rimborso') {
                    refund.value = '';
                }
                this.calculateRealTime();
            });
        });
        
        // Event listener per i calcoli in tempo reale
        document.getElementById('stakeA').addEventListener('input', () => this.calculateRealTime());
        document.getElementById('oddsA').addEventListener('input', () => this.calculateRealTime());
        document.getElementById('oddsB').addEventListener('input', () => this.calculateRealTime());
        document.getElementById('refundValue').addEventListener('input', () => this.calculateRealTime());
        document.getElementById('exchangeCommission').addEventListener('input', () => this.calculateRealTime());
        // Event listener per copiare il valore stakeB
        document.getElementById('stakeB').addEventListener('click', () => {
            const stakeBElement = document.getElementById('stakeB');
            const value = stakeBElement.textContent.trim();
            
            if (value && value !== '') {
                // Copia il valore negli appunti
                navigator.clipboard.writeText(value).then(() => {
                    // Feedback visivo temporaneo
                    stakeBElement.classList.add('copied');
                    
                    setTimeout(() => {
                        stakeBElement.classList.remove('copied');
                        stakeBElement.title = originalTitle;
                    }, 1000);
                }).catch(err => {
                    console.error('Errore nella copia:', err);
                    // Fallback per browser che non supportano clipboard API
                    this.fallbackCopyText(value);
                });
            }
        });
    }

    /**
    * Calcola in tempo reale i valori di arbitraggio per le scommesse
    * Supporta tre tipi di scommessa: normale, bonus e rimborso
    */
    calculateRealTime() {
        const stakeA = parseFloat(document.getElementById('stakeA').value) || 0;
        const oddsA = parseFloat(document.getElementById('oddsA').value) || 0;
        const oddsB = parseFloat(document.getElementById('oddsB').value) || 0;
        const betType = document.querySelector('input[name="betType"]:checked').value;
        const refundValue = parseFloat(document.getElementById('refundValue').value) || 0;
        
        if (stakeA === '' || oddsA === '' || oddsB === '' || 
        stakeA <= 0 || oddsA <= 0 || oddsB <= 0) {
            document.getElementById('stakeB').textContent = '';
            document.getElementById('profit').textContent = '';
            document.getElementById('rating').textContent = '';
            // Reset del colore del profit
            const profitElement = document.getElementById('profit');
            profitElement.classList.remove('positive-profit', 'negative-profit');
            return;
        }
        if (betType === 'rimborso' && (refundValue === '' || refundValue <= 0)) {
            document.getElementById('stakeB').textContent = '';
            document.getElementById('profit').textContent = '';
            document.getElementById('rating').textContent = '';
            return;
        }
        
        const exchangeCommissionInput = document.getElementById('exchangeCommission').value;
        const commission = exchangeCommissionInput === '' ? 0.045 : parseFloat(exchangeCommissionInput) / 100;
        let stakeB, profit, rating;
        
        if (betType === 'rimborso' && refundValue > 0) {
            // Calcolo in modalità rimborso
            stakeB = (oddsA * stakeA - refundValue) / (oddsB - commission);
            const lossA = (oddsA * stakeA - stakeA) - (oddsB * stakeB - stakeB);
            const lossB = stakeB * (1 - commission) - stakeA + refundValue;
            const ratingA = lossA / refundValue;
            const ratingB = lossB / refundValue;
            rating = Math.min(ratingA, ratingB) * 100;
            profit = Math.min(lossA, lossB);
        } else {
            // Calcolo in modalità normale/bonus
            stakeB = (oddsA * stakeA) / (oddsB - commission);
            const lossA = (oddsA * stakeA - stakeA) - (oddsB * stakeB - stakeB);
            const lossB = stakeB * (1 - commission) - stakeA;
            const ratingA = (1 + lossA / stakeA) * 100;
            const ratingB = (1 + lossB / stakeA) * 100;
            rating = Math.min(ratingA, ratingB);
            if (betType === 'bonus') {
                profit = stakeA + Math.min(lossA, lossB);
            }
            else {
                profit = Math.min(lossA, lossB);
            }
        }
        
        // Aggiorna l'interfaccia con i risultati calcolati
        document.getElementById('stakeB').textContent = stakeB.toFixed(2);
        document.getElementById('profit').textContent = `${profit.toFixed(2)}€`;
        document.getElementById('rating').textContent = `${rating.toFixed(2)}%`;
        // Colora il profitto in base al valore
        const profitElement = document.getElementById('profit');
        if (profit > 0) {
            profitElement.style.color = '#059669';
            profitElement.classList.remove('negative-profit');
            profitElement.classList.add('positive-profit');
        } else {
            profitElement.style.color = '#dc2626';
            profitElement.classList.remove('positive-profit');
            profitElement.classList.add('negative-profit');
        }
    }
}

// Inizializza l'app
const app = new PuntaBanca();

// Esporta l'istanza globalmente per permettere l'accesso dai button onclick nell'HTML
window.app = app;